import request from "@/util/http";

/**
 * 热搜词列表（用户端，已启用，按sort排序）
 */
export function list() {
	return request({
		url: '/goods/shop/hot_search/list',
		method: 'get'
	})
}
